import Ajax from '../js/common/ajax';

export default {
	abs_list(accountSetsId) {
		return Ajax.get("/abstracts/listQuery/"+accountSetsId)
	}, 
    abs_getRoot(params) {
		return Ajax.get("/abstracts/getRoot",params)
	}, 
    abs_getChild(params) {
		return Ajax.get("/abstracts/getChild",params)
	}, 
    abs_add(params) {
        return Ajax.post(`/abstracts/add`, params)
    },
    abs_edit(params) {
        return Ajax.post(`/abstracts/edit`, params)
    },
    abs_del(id) {
        return Ajax.post(`/abstracts/del/`+id)
    },

    act_list(accountSetsId) {
		return Ajax.get("/act/listQuery/"+accountSetsId)
	}, 
    act_add(params) {
        return Ajax.post(`/act/add`, params)
    },
    act_edit(params) {
        return Ajax.post(`/act/edit`, params)
    },
    act_del(id) {
        return Ajax.post(`/act/del/`+id)
    },

    sett_list(accountSetsId) {
		return Ajax.get("/settlementType/list/"+accountSetsId)
	}, 
    sett_add(params) {
        return Ajax.post(`/settlementType/add`, params)
    },
    sett_edit(params) {
        return Ajax.post(`/settlementType/edit`, params)
    },
    sett_del(id) {
        return Ajax.post(`/settlementType/del/`+id)
    },

    cd_list(params) {
		return Ajax.get("/CashDaily/listQuery",params)
	}, 
    cd_nobindlist(params) {
		return Ajax.get("/CashDaily/getNoBindList",params)
	},  
    cd_add(params) {
        return Ajax.post(`/CashDaily/add`, params)
    },
    cd_edit(params) {
        return Ajax.post(`/CashDaily/edit`, params)
    },
    cd_del(id) {
        return Ajax.post(`/CashDaily/del/`+id)
    },
    summaryAct(params){
        return Ajax.get("/CashDaily/summaryAct",params)
    },
    summaryTradeType(params){
        return Ajax.get("/CashDaily/summaryTradeType",params)
    },
    summaryTradeActType(params){
        return Ajax.get("/CashDaily/summaryTradeActType",params)
    },
    bindVoucher(id,params){
        return Ajax.post(`/CashDaily/bindVoucher/`+id,params)
    },
    unbindVoucher(params){
        return Ajax.post(`/CashDaily/unbindVoucher/`,params)
    },
    getBindVoucherData(voucherId){
        return Ajax.get(`/CashDaily/getBindVoucherData/`+voucherId)
    },

    trade_list(params) {
		return Ajax.get("/tradeType/list",params)
	},  
    trade_add(params) {
        return Ajax.post(`/tradeType/add`, params)
    },
    trade_edit(params) {
        return Ajax.post(`/tradeType/edit`, params)
    },
    trade_del(id) {
        return Ajax.post(`/tradeType/del/`+id)
    },
      //亿企日记账导入
    yqImport(params) {
    return Ajax.post("/CashDaily/yq/importCashDaily",params,{ 'Content-Type': 'multipart/form-data' })
    },
    unbindVoucherBatch(params){
        return Ajax.post(`/CashDaily/unbindVoucherBatch/`,params)
    },
}